import { getAuth, signInAnonymously, onAuthStateChanged, Auth } from 'firebase/auth';

const anonymousUser = async () => {
  const auth = getAuth();
  onAuthStateChanged(auth, user => {
    if (!user) {
      anonymousLogin(auth);
    }
  });
};

const anonymousLogin = (auth: Auth) => {
  signInAnonymously(auth).catch(error => {
    console.error(error);
  });
};

export default anonymousUser;
